import { getDocs } from 'firebase/firestore'

import { builderVideosCollection } from './builder-videos-firestore-refs'

import { handleError } from '@/error/handle-error'
import { type CardActivityType } from '@/models/card-activity/card-activity.model'

export type BuilderVideoType = CardActivityType | 'bulk_creator'

export interface BuilderVideo {
  id: string
  title: string
  description: string
  videoUrl: string
  type: BuilderVideoType
}

export async function getBuilderVideos() {
  try {
    const querySnapshot = await getDocs(builderVideosCollection)

    return querySnapshot.docs.map(doc => doc.data() as BuilderVideo)
  } catch (error) {
    handleError(error)
  }
}
